/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { Table, Empty } from 'antd';
import AccountingDetailsContext from '../../../contexts/accounting-context/AccountingDetailsContext';
import UserContext from '../../../contexts/user-context/UserProvider';
import TableColumns from './TableColumns';
import JournalsContext from '../../../contexts/accounting-context/JournalsContext';
import { useTranslation } from 'react-i18next';

const JournalsDetailsTable = ({ type }) => {
  const { user } = useContext(UserContext);
  const {
    fetchedJournalsDetails,
    fetchCount,
    setIsLoading,
    setFetchCount,
    setModalOpened,
    setSelectedJournals,
    isLoading,
    setModalOpenedCreate
  } = useContext(JournalsContext);
  const { t } = useTranslation();

  // map all data to dataSource
  const [tableDataSource, setTableDataSource] = useState([]);
  const mapDataSource = (data) => {
    return data.map((obj, index) => ({
      ...obj,
      key: obj.id,
      index: index + 1,
      name: obj?.name ? obj.name : '',
      description: obj?.name ? obj.name : '',
      title: obj?.title ? obj.title : '',
      the_amount: obj?.balance
        ? obj.balance
        : obj.initial_balance
        ? obj.initial_balance
        : ''
    }));
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setTableDataSource(fetchedJournalsDetails && fetchedJournalsDetails);
    }
    return () => {
      isMounted = false;
    };
  }, [fetchCount, fetchedJournalsDetails]);

  return (
    <>
      <Table
        locale={{
          emptyText: (
            <Empty description={false}>{t('Messages.noDataAvailable')}</Empty>
          )
        }}
        pagination={{ defaultPageSize: 5, hideOnSinglePage: true }}
        className="antd-custom-table"
        dataSource={tableDataSource}
        columns={TableColumns(
          fetchedJournalsDetails,
          setModalOpened,
          setModalOpenedCreate,
          setFetchCount,
          setSelectedJournals,
          setIsLoading,
          user?.token,
          type
        )}
        loading={isLoading}
        // scroll={{ x: 400 }}
        footer={false}
      />
    </>
  );
};

export default JournalsDetailsTable;
